var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.29067 16.6622C6.15381 16.568 6.0265 16.462 5.90725 16.3427C4.83331 15.2688 4.83331 13.5403 4.83331 10.0833C4.83331 6.62637 4.83331 4.89788 5.90725 3.82394C6.9812 2.75 8.70968 2.75 12.1666 2.75H15.8333C19.2903 2.75 21.0188 2.75 22.0927 3.82394C23.1666 4.89788 23.1666 6.62637 23.1666 10.0833C23.1666 13.5403 23.1666 15.2688 22.0927 16.3427C21.9735 16.462 21.8461 16.568 21.7093 16.6622",
    stroke: "#2177FE",
    strokeWidth: 1.375,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9624 15.5155C10.1699 15.9981 8.09191 16.9836 9.35754 18.2167C9.97578 18.8191 10.6644 19.25 11.53 19.25H16.4699C17.3356 19.25 18.0242 18.8191 18.6424 18.2167C19.908 16.9836 17.8301 15.9981 17.0375 15.5155C15.1791 14.3837 12.8209 14.3837 10.9624 15.5155Z",
    stroke: "#2177FE",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2916 10.0833C16.2916 11.3489 15.2656 12.375 14 12.375C12.7343 12.375 11.7083 11.3489 11.7083 10.0833C11.7083 8.81764 12.7343 7.79163 14 7.79163C15.2656 7.79163 16.2916 8.81764 16.2916 10.0833Z",
    stroke: "#2177FE",
    strokeWidth: 1.375
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_208",
    x: -1,
    y: 0,
    width: 30,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_208"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_208",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvite);
export default __webpack_public_path__ + "static/media/invite.3dc3496c01fbd5289eb44b5ba230749a.svg";
export { ForwardRef as ReactComponent };